<template>
  <b-row>
    <b-col cols="12">
      <form-wizard-number />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import FormWizardNumber from './FormWizardNumber.vue'

export default {
  components: {
    BRow,
    BCol,
    FormWizardNumber,
  },
  metaInfo: {
    title: 'Quote Travel Insurance | Safetravel.today - Making Travel Insurance Easy',
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { name: 'description', content: 'Get instant travel insurance quotes and buy online with Safetravel.today. Secure, easy, and fast coverage for your next trip.' },
      { name: 'keywords', content: 'travel insurance, online travel insurance, buy travel insurance, travel insurance quotes, safe travel app, Safetravel.today' },
      { property: 'og:title', content: 'Safetravel.today - Easy Online Travel Insurance' },
      { property: 'og:description', content: 'Plan safe trips and buy travel insurance online in minutes with Safetravel.today.' },
      { property: 'og:image', content: 'https://safetravel.today/images/quotation.png' },
      { property: 'og:type', content: 'website' },
      { name: 'robots', content: 'index, follow' },
    ],
    script: [
      {
        type: 'application/ld+json',
        json: {
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'Safetravel.today',
          url: 'https://safetravel.today',
          logo: 'https://safetravel.today/logo.png',
          sameAs: [
            'https://www.facebook.com/safetraveltoday',
            'https://www.linkedin.com/company/safe-travel',
            'https://x.com/safetraveltoday'
          ],
          description: 'Safetravel.today is a travel insurance company offering secure, flexible, and affordable coverage for safe journeys worldwide.'
        },
      },
    ],
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
